module.exports = __webpack_public_path__ + "img/binary-lock.5ea23dc7.svg";